import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIanaTimeZone } from '../utils/dateTimeUtils';

// /////////////////////////////////////////////////////////////////////////////////////////////////
export function useOrgType() {
  const org = useSelector((state) => state.userOrganization);

  const memoized = useMemo(() => {
    if (!org) {
      const fallbackAbbrev = 'EST';
      return {
        isRoot: false,
        isReseller: false,
        isFleet: false,
        entityId: null,
        entityName: '',
        timezoneAbbrev: fallbackAbbrev,
        timezoneIana: getIanaTimeZone(fallbackAbbrev),
        featureFlags: {},
        assetModelsNames: [],
      };
    }

    const isRoot = org.entityType === 'Org-Root';
    const isReseller = org.entityType === 'Org-Reseller';
    const isFleet = org.entityType === 'Org-Fleet';
    const timezoneAbbrev = org.generalConfig?.timezone ?? 'EST';
    const timezoneIana = getIanaTimeZone(timezoneAbbrev);
    const assetModelsNames = Object.keys(org.assetModels || {}).sort();

    return {
      isRoot,
      isReseller,
      isFleet,
      entityId: org.entityId,
      entityName: org.entityName,
      timezoneAbbrev,
      timezoneIana,
      featureFlags: org.featureFlags || {},
      assetModelsNames,
    };
  }, [org]);

  return memoized;
}
